import AccordionDetails from '@material-ui/core/AccordionDetails';

export default AccordionDetails;
